<div class="flex scrollbar" data-cy="tabsbar-container">
    @for (tab of tabs(); track tab.tabId) {
        <button
            class="flex items-center px-4 py-2 border-0 tab"
            [class]="tabs().length > 1 ? 'justify-content-between' : 'justify-content-start'"
            [class]="isTabActive(tab) ? 'active' : 'inactive'"
            (click)="handleTabClicked(tab)"
            [pTooltip]="tooltipContent"
            [tooltipDisabled]="$index === 0"
            showDelay="1000"
            tooltipPosition="top"
            data-cy="tab-button"
            [attr.data-cy-tab-id]="tab.tabId"
            [attr.data-cy-tab-active]="isTabActive(tab)"
        >
            @if (!!tab.tabTitleIconDefinition) {
                <fa-icon class="tab__icon" [icon]="tab.tabTitleIconDefinition" data-cy="tab-icon" />
            }
            <div class="tab__content" data-cy="tab-content">
                <div class="fw-600 text-l w-full truncate-text text-left leading-none" data-cy="tab-title">
                    {{ tab.tabTitle }}
                </div>
                @if (!!tab.tabText) {
                    <div class="text-m text tab-text-wrap leading-none" data-cy="tab-text">
                        {{ tab.tabText }}
                    </div>
                }
            </div>
            @if (tabs().length > 1) {
                <button
                    (click)="handleTabClosed($event, tab)"
                    class="border-0 bg-transparent cursor-pointer hover:border-radius-round"
                    data-cy="tab-close-button"
                >
                    <fa-icon [icon]="faXMark" class="tab__close-btn" data-cy="tab-close-icon"></fa-icon>
                </button>
            }
            <ng-template #tooltipContent>
                <div class="fw-500 text-xm">{{ tab.tabTitle }}</div>
                <div class="fw-500 text-xs">{{ tab.tabText }}</div>
            </ng-template>
        </button>
    }
    @if (tabs.length < maxTabsAllowed()) {
        <button
            class="flex justify-center pl-6 pr-2 add-button overflow-hidden bg-transparent border-0"
            [ngClass]="{ active: isNewTabButtonActive() }"
            pTooltip="Open new tab"
            tooltipPosition="top"
            (click)="op.toggle($event)"
            data-cy="add-tab-button"
        >
            <fa-icon [icon]="faCirclePlus" class="c-kashmir-blue content-center tab__icon" data-cy="add-tab-icon" />
        </button>
    }

    <p-popover
        #op
        (onShow)="handleOverlayPanelShown()"
        (onHide)="handleOverlayPanelHidden()"
        styleClass="new-tab-panel"
        [dismissable]="true"
        [pt]="addTabPopoverPtOptions"
        data-cy="new-tab-panel"
    >
        <ul class="list-none m-0 p-0" data-cy="new-tab-menu">
            @for (item of actionItems; track item.name) {
                <li>
                    <a
                        tabindex="0"
                        (keyup)="handleNewTabOpened(item.url, $event)"
                        (click)="handleNewTabOpened(item.url, $event)"
                        class="tab-action-item"
                        [attr.data-item-name]="item.name"
                        data-cy="new-tab-menu-item"
                        [attr.data-cy-item-name]="item.name"
                    >
                        {{ item.name }}
                    </a>
                </li>
            }
        </ul>
    </p-popover>
</div>
